<template>
	<page-container class="container no-heading-image" :page="page">
		<div
			id="hiring-assistant"
			data-show-button
			data-show-banner="false"
			data-open
			data-open-mobile="false"
		></div>

		<div v-if="page.headingImages">
			<heading-image
				v-for="(item, index) in page.headingImages"
				:key="index"
				:heading-image="item"
				:title="page.title || page.header"
			/>
		</div>

		<content-blocks v-if="page.contentblocks?.length" :items="page.contentblocks" />

		<main-content
			:title="(page.title || page.header) ?? 'Page not found'"
			:subtitle="page.subtitle"
			:content="page.content"
			:side-image="{
				image: page.sideImage,
				imageAlt: page.sideImageAlt,
				imageWebp: page.sideImageeWebp,
			}"
		/>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();

useHead({
	bodyAttrs: {
		class: 'subpage hide-zenchef',
	},
});

onUpdated(() => {
	reloadNuxtApp();
});
</script>

<style lang="scss">
body.hide-zenchef .zc-widget-config,
body.hide-zenchef iframe[class^='ZC_sdk__zc-iframe_'],
body.hide-zenchef iframe[class*=' ZC_sdk__zc-iframe_'] {
	display: none !important;
}
</style>
